import { memo } from 'react';

interface StockLevelCellProps {
  value: number | null | undefined;
  maxStock?: number;
  criticalThreshold?: number;
  warningThreshold?: number;
  showValue?: boolean;
}

export const StockLevelCell = memo(({
  value,
  maxStock = 100,
  criticalThreshold = 10,
  warningThreshold = 30,
  showValue = true
}: StockLevelCellProps) => {
  if (value === null || value === undefined) {
    return <span style={{ color: 'var(--color-text-muted)' }}>—</span>;
  }

  const percentage = Math.min(100, (value / maxStock) * 100);

  // Determine color based on stock level
  let color: string;

  if (value <= criticalThreshold) {
    color = 'var(--color-negative)';
  } else if (value <= warningThreshold) {
    color = 'var(--color-warning-600)';
  } else {
    color = 'var(--color-positive)';
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        minWidth: '120px'
      }}
    >
      {/* Progress bar */}
      <div
        style={{
          flex: 1,
          height: '6px',
          background: 'var(--color-neutral-100)',
          borderRadius: 'var(--radius-full)',
          overflow: 'hidden'
        }}
      >
        <div
          style={{
            width: `${percentage}%`,
            height: '100%',
            background: color,
            borderRadius: 'var(--radius-full)',
            transition: 'width 0.3s ease'
          }}
        />
      </div>

      {/* Value display */}
      {showValue && (
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: '12px',
            fontWeight: 500,
            color: color,
            minWidth: '36px',
            textAlign: 'right'
          }}
        >
          {value.toLocaleString('tr-TR')}
        </span>
      )}
    </div>
  );
});

StockLevelCell.displayName = 'StockLevelCell';
